module.exports = __webpack_public_path__ + "img/pc_join.92c2c244.png";